import employee from '@/api/employee'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  found_data: {},
  positions: [],
  statuses: [],
  provinces: [],
  districts: [],
  communes: [],
  villages: [],
  id_types: [],
  divisions: [],
  departments: [],
  employees: [],
  shifts: [],
  spouse_occupations: [],
  id_card_activated: null,
  photo_exists: null,
  status: 'Active',
  branch_id: null
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_FOUND_DATA (state, data) {
    state.found_data = data
  },
  SET_POSITIONS (state, data) {
    state.positions = data
  },
  SET_DIVISIONS (state, data) {
    state.divisions = data
  },
  SET_DEPARTMENTS (state, data) {
    state.departments = data
  },
  SET_EMPLOYEES (state, data) {
    state.employees = data
  },
  SET_SHIFTS (state, data) {
    state.shifts = data
  },
  SET_STATUSES (state, data) {
    state.statuses = data
  },
  SET_PROVINCES (state, data) {
    state.provinces = data
  },
  SET_DISTRICTS (state, data) {
    state.districts = data
  },
  SET_COMMUNES (state, data) {
    state.communes = data
  },
  SET_VILLAGES (state, data) {
    state.villages = data
  },
  SET_ID_TYPES (state, data) {
    state.id_types = data
  },
  SET_SPOUSE_OCCUPATIONS (state, data) {
    state.spouse_occupations = data
  },
  SET_ID_CARD_ACTIVATED (state, data) {
    state.id_card_activated = data
  },
  SET_PHOTO_EXISTS (state, data) {
    state.photo_exists = data
  },
  SET_STATUS (state, data) {
    state.status = data
  },
  SET_BRANCH_ID (state, data) {
    state.branch_id = data
  }
}

export const actions = {
  fetch (context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        id_card_activated: context.state.id_card_activated,
        photo_exists: context.state.photo_exists,
        status: context.state.status,
        all_branch: Array.isArray(context.state.branch_id)
          ? context.state.branch_id.length
            ? undefined
            : true
          : true
      },
      attrubutes
    )
    return employee.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store (context, data) {
    return employee.store(data)
  },
  update (context, data) {
    return employee.update(data)
  },
  uploadPhoto (context, data) {
    return employee.uploadPhoto(data)
  },
  destroy (context, id) {
    return employee.destroy(id)
  },
  async find (context, id) {
    if (_.isEmpty(context.state.found_data)) {
      let response = await employee.find(id)
      context.commit('SET_FOUND_DATA', response.data)
    }
  },

  fetchEmployees (context, attributes = {}) {
    let params = {
      page: -1,
      fields: {
        setup_staff_information: 'staff_id,name_en,name_kh,gender'
      },
      header: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      },
      ...attributes
    }

    return employee.get({ params }).then(response => {
      context.commit('SET_EMPLOYEES', response.data)
      return Promise.resolve(response)
    })
  },

  async dataBeforeCreate (context) {
    let position = await employee.employeePosition({
      header: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
    context.commit('SET_POSITIONS', position)

    let status = await employee.employeeStatus({
      header: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
    context.commit('SET_STATUSES', status)

    let province = await employee.employeeProvince({
      header: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
    context.commit('SET_PROVINCES', province)

    let id_type = await employee.employeeIdType({
      header: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
    context.commit('SET_ID_TYPES', id_type)

    let accupation = await employee.employeeSpouseOccupation({
      header: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
    context.commit('SET_SPOUSE_OCCUPATIONS', accupation)

    let division = await employee.getDivision({
      header: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
    context.commit('SET_DIVISIONS', division)

    let employeePro = await employee.getEmployee({
      header: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
    context.commit('SET_EMPLOYEES', employeePro.data)

    let shift = await employee.getShift({
      header: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
    context.commit('SET_SHIFTS', shift.data)
  },
  getImployeeId (context, hired_date) {
    return employee.getEmployeeId(hired_date)
  },
  async getDistrict (context, province_code) {
    context.commit('SET_DISTRICTS', [])
    context.commit('SET_COMMUNES', [])
    context.commit('SET_VILLAGES', [])
    let response = await employee.getDistrict(province_code)
    context.commit('SET_DISTRICTS', response)
  },
  async getCommune (context, district_code) {
    context.commit('SET_COMMUNES', [])
    context.commit('SET_VILLAGES', [])
    let response = await employee.getCommune(district_code)
    context.commit('SET_COMMUNES', response)
  },
  async getVillage (context, commune_code) {
    context.commit('SET_VILLAGES', [])
    let response = await employee.getVillage(commune_code)
    context.commit('SET_VILLAGES', response)
  },
  async getDepartment (context, division_id) {
    context.commit('SET_DEPARTMENTS', [])
    let response = await employee.getDepartment(division_id)
    context.commit('SET_DEPARTMENTS', response)
  },

  printCard (context, data) {
    return employee.printCard({
      params: {
        side: data.side,
        staff_id_list: data.staff_id_list,
        type: data.type
      }
    })
  },
  // generate student list as excel
  exportExcel (context, data) {
    return employee.exportExcel(data)
  },
  Getbranch (context, data) {
    return employee.branch(data)
  },

  transferBranch (context, data) {
    return employee.transferBranch(data)
  },
  increasePrinterCardCounter (context, staffId) {
    return employee.increasePrinterCardCounter(staffId)
  }
}
